// travel-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'trv.privateRefundSuffix': 'tas med på neste lønnsutbetaling uten å øke skattepliktig lønn, feriepenger, AGA eller OTP.',
  'trv.rejectReasonRequired': 'Legg inn en kort begrunnelse for avvisningen.',
  'trv.showApproved': 'Vis godkjente',
  'trv.tripCounts': '{mileage} kjøringer · {stays} overnattinger · {expenses} utlegg',
  'trv.expenseSaved': 'Utlegg lagret.',
  'trv.expenseSaveFailed': 'Kunne ikke lagre utlegg.',
  'trv.voucherFetchFailed': 'Kunne ikke hente bilaget.',
  'trv.voucherNoViewLink': 'Fant ingen visningslenke for bilaget.',
  'trv.viewVoucher': 'Vis bilag',
  'trv.travelSaveFailed': 'Kunne ikke lagre reisen.',
  'trv.statusUpdateFailed': 'Kunne ikke oppdatere reisestatus.',
  'trv.deleteConfirm': 'Slette reiseregning "{purpose}"?',
  'trv.travelDeleted': 'Reise slettet.',
  'trv.travelDeleteFailed': 'Kunne ikke slette reisen.',
  'trv.travelCopied': 'Reise kopiert til nytt utkast.',
  'trv.travelCopyFailed': 'Kunne ikke kopiere reisen.',
  'trv.viewDetails': 'Se detaljer',
  'trv.editLine': 'Rediger linjen',
  'trv.editedAfterSubmit': 'Endret etter innsending',
  'trv.tollAmount': 'bom {amount}',
  'trv.deleteTrip': 'Slett kjøreturen',
  'trv.deleteStay': 'Slett overnattingen',
  'trv.attachmentMark': '● Vedlegg',
  'trv.deleteExpense': 'Slett utlegget',
  'trv.history': 'Historikk',
  'trv.historyHelp': 'Hvem som har endret reiseregningen, og når.',
  'trv.companyPaidDirect': '{amount} betalt med firmakort/driftskonto bokføres direkte og inngår ikke i lønnsutbetalingen.',
  'trv.pickEmployee': 'Velg ansatt.',
  'trv.purposeRequired': 'Fyll ut formålet med reisen.',
  'trv.travelSaved': 'Reise lagret.',
  'trv.calculateSubsistence': 'Beregn diett',
  'trv.addStop': '+ Legg til stopp',
  'trv.addPassenger': '+ Legg til ny passasjer',
  'trv.addTrailerKm': '+ Kjørt med tilhenger',
  'trv.addForestRoadKm': '+ Kjørt på skog- og anleggsvei',
  'trv.pickDateAndStayType': 'Velg dato og type opphold.',
  'trv.lodgingDescriptionRequired': 'Legg inn beskrivelse av overnattingsstedet.',
  'trv.stayTypeHint': 'Velg annen overnatting om du for eksempel overnattet i en leid leilighet eller hybel. (Typisk Airbnb eller lignende).',
  'trv.otherStayHintLead': 'Brukes kun hvis det ikke var mulig å lage mat på overnattingsstedet. Hvis du overnattet privat hos noen, eller hvis overnattingsstedet hadde f.eks en platetopp, skal du velge',
  'trv.lodgingHint': 'Påkrevd. Legg inn navn og adresse på overnattingssted.',
  'trv.mealsHint': 'Marker de måltidene du selv betalte for. Hadde du frokost inkludert i overnattingen skal du ikke velge frokost her.',
  'trv.calculatedSubsistence': 'Beregnet diett ({rate} kr/døgn · statens sats)',
  'trv.expenseRequirements': 'Beskrivelse, beløp og minst ett vedlegg kreves.',
});
